import React from 'react';
import PropTypes from 'prop-types';
import ReactConfirmAlert, {confirmAlert} from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css'
import Tour from './Tour';
import uniqueHash from '../../../../utils/uniqueHash';
import routeSettings from '../../../../config/router';
import {Button} from "../../../../components/Button";


class TourList extends React.Component {
  constructor(props) {
    super(props);
    this.deleteTour = this.deleteTour.bind(this);
    this.state = {
      showDialog: false,
    }
  }

  static propTypes = {
    tourList: PropTypes.array,
    getTourList: PropTypes.func,
    deleteTour: PropTypes.func,
    history: PropTypes.object,
    user: PropTypes.object,
  };

  componentWillMount() {
    this.props.getTourList()
  }

  deleteTour(tourId) {
    confirmAlert({
      title: 'Delete Tour',
      message: 'Are you sure you want to delete this tour?',
      buttons: [
        {
          className: 'test',
          label: 'Yes',
          onClick: () => this.props.deleteTour({tour_id: tourId})
        },
        {
          label: 'No',
          onClick: () => this.setState({showDialog: false})
        }
      ],
    })
  }

  render() {
    const {
      tourList,
      history,
      user
    } = this.props;

    return (
      <div className="tour">
        <h2 className="title-page">My Inventory</h2>
        <div className="tour__wrap">
          {
            user.vendorType === 'tour' ?
              (
                <ul className="tour__list">
                  {
                    this.state.showDialog &&
                    <ReactConfirmAlert
                    />
                  }
                  <li className="tour__item tour__item-create">
                    <Button
                      className="ion-ios-plus-empty"
                      name="Create New Tour"
                      onClick={() => this.props.history.push(routeSettings.vendor.newTour)}
                    />
                  </li>
                  {tourList.map((item) => {
                    return (
                      <Tour
                        key={uniqueHash()}
                        tourId={item.id}
                        title={item.title}
                        pricePerson={item.priceOnePerson}
                        tourPhotos={item.tourPhotos || []}
                        onEditTour={(tourId) => {
                          history.push(`${routeSettings.vendor.editTour}/${tourId}`)
                        }}
                        deleteTour={this.deleteTour}
                        isNew={item.isNew}
                      />
                    )
                  })}
                </ul>
              ) : null
          }

        </div>
      </div>
    )
  }
}

export default TourList;


// WEBPACK FOOTER //
// ./src/app/containers/Vendor/Tour/TourList/Component.js